import { useEffect, useState } from "react";
import "./style.css";
// import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { apiCreateBuyer } from "../../../api/master";
// import { apiCity, apiState } from "../../../api/stateAndCity";
import buyerSchema from "../../../validations/buyerSchema";
import { inputOnlyNumber } from "../../../utils";

function BuyerAdd(props) {
  // const [stateValue,setStateValue] = useState([]);
  // const [city,setCity] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [selectedcode, setSelectedCode] = useState("");
  const [shownew, setShownew] = useState(false);

  const handlecodeChange = (selectedcode) => {
    setSelectedCode(selectedcode);
  };

  // const stateListMap = stateValue?.flatMap(el => {
  //   return {
  //     value: el?.state_id,
  //     label: el.name,
  //   };
  // });

  // const filterCityName = city?.filter(el => Number(el?.state_id) === Number(selectedcode?.value));
  // const cityListMap = filterCityName?.flatMap(el => {
  //       return {
  //           value: el?.city_id,
  //           label: el.city,
  //       };
  // });

  const buyerFormik = useFormik({
    initialValues: {
      buyer_name: "",
      buyer_address: "",
      // "buyer_state_id": "",
      // "buyer_city_id": "",
      // "buyer_pincode": ""
    },
    validationSchema: buyerSchema.validateBuyerAdd(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      const decod = {
        buyer_name: values.buyer_name,
        buyer_address: values.buyer_address,
        // buyer_state_id: Number(values.buyer_state_id),
        // buyer_city_id:Number(values.buyer_city_id),
        // buyer_pincode:Number(values.buyer_pincode)
      };
      await apiCreateBuyer(decod)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          setShownew(true);
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
        });
    },
    onReset: async (values) => {
      setSelectedCode(null);
      buyerFormik.resetForm();
      setShownew(false);
      setSuccess("");
    },
  });

  // async function getStateAndCity() {
  //   await apiState().then(result => setStateValue(result.data.data.list));
  //   await apiCity().then(result => setCity(result?.data?.data.list));
  // }

  // useEffect(function () {
  //   getStateAndCity();
  // }, []);

  useEffect(
    function () {
      const timer = setTimeout(() => {
        setSuccess("");
        setError("");
      }, 5000);
      return () => clearTimeout(timer);
    },
    [success, error]
  );

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Add Supplier
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={buyerFormik.handleSubmit}
          onReset={buyerFormik.handleReset}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="branch_name">
              Supplier Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="buyer_name"
              {...buyerFormik.getFieldProps("buyer_name")}
            />
            {buyerFormik.errors.buyer_name && shownew != true ? (
              <div className="text-danger small">
                {buyerFormik.errors.buyer_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="buyer_address">Supplier Address</label>
            <textarea
              type="text"
              className="form-control"
              id="buyer_address"
              {...buyerFormik.getFieldProps("buyer_address")}
            />
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="state_id">
              State <span className="text-danger">*</span>
            </label>
            <Select
              options={stateListMap}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  minHeight: "0px",
                }),
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
                input: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }),
                dropdownIndicator: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
              }}
              value={selectedcode}
              classNamePrefix="react-select"
              tabSelectsValue
              onChange={(selectedOption) => {
                handlecodeChange(selectedOption);
                buyerFormik.setFieldValue("buyer_state_id", selectedOption.value);
              }}
              name="buyer_state_id"
            />
            {buyerFormik.errors.buyer_state_id && shownew != true ? (
              <div className="text-danger small">
                {buyerFormik.errors.buyer_state_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="buyer_city_id">
              City <span className="text-danger">*</span>
            </label>
            <select
              type="text"
              className="form-select"
              id="item_unit"
              disabled={cityListMap.length === 0 ? true : false}
              {...buyerFormik.getFieldProps("buyer_city_id")}
              >
              <option value="" hidden>
                Select...
              </option>
              {cityListMap.map((list) => {
                  return <option value={list.value}>{list.label}</option>;
              })}
            </select>
            
            {buyerFormik.errors.buyer_city_id && shownew != true ? (
              <div className="text-danger small">
                {buyerFormik.errors.buyer_city_id}
              </div>
            ) : null}
          </div> */}
          {/* <div className="col-md-6">
            <label htmlFor="buyer_pincode">
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onKeyDown={inputOnlyNumber}
              // minLength={5}
              maxLength={9}
              className="form-control"
              id="buyer_pincode"
              {...buyerFormik.getFieldProps("buyer_pincode")}
            />
            {buyerFormik.errors.buyer_pincode && shownew != true ? (
              <div className="text-danger small">
                {buyerFormik.errors.buyer_pincode}
              </div>
            ) : null}
          </div> */}
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="reset"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  type="reset"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default BuyerAdd;
